module.exports = __webpack_public_path__ + "static/media/text.440f137c.svg";